module.exports = __webpack_public_path__ + "media/src/assets/Images/MarkUnread-c22539a6190be63382d19936068b506f.svg";